import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { store } from "./redux/store";
import { MsalProvider } from "@azure/msal-react";
import "./App.css";
import MainLayout from "./layouts/mainLayout";
import ProtectedRoute from "./components/protectedRoute";
import Products from "./pages/products";
import BusinessUnit from "./pages/businessUnit";
import Packages from "./pages/packagesCrud";
import Billing from "./pages/billing";
import AdditionalCost from "./pages/additionalCost";
import ReporteCostos from "./pages/reporteCostos";
import Login from "./pages/login";
import PackagesView from "./pages/packagesView";
import PricingInstanceFacturacion from "./pages/pricingInstanceFacturacion";
import Contador from "./pages/contador";

const LayoutRoute = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const allRoutes = [
  { path: "/Products", element: <Products /> },
  { path: "/BusinessUnit", element: <BusinessUnit /> },
  { path: "/Packages", element: <Packages /> },
  { path: "/Billing", element: <Billing /> },
  { path: "/additionalCost", element: <AdditionalCost /> },
  { path: "/reporteCostos", element: <ReporteCostos /> },
  { path: "/PackagesView", element: <PackagesView /> },
  { path: "/Facturacion", element: <PricingInstanceFacturacion /> },
  { path: "/contador", element: <Contador /> },
];

const RedirectToFirstAllowed = () => {
  const allowedRoutes = useSelector((state) => state?.user?.allowedRoutes || []);
  if (!allowedRoutes.length || typeof allowedRoutes[0] !== "string") {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={allowedRoutes[0]} replace />;
};

const AppRoutes = () => {
  const allowedRoutes = useSelector((state) => state?.user?.allowedRoutes || []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {allRoutes
        .filter(({ path, parentPath }) =>
          allowedRoutes.includes(parentPath || path)
        )
        .map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<LayoutRoute>{element}</LayoutRoute>}
          />
        ))}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RedirectToFirstAllowed />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <RedirectToFirstAllowed />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App({ msalInstance }) {
  const content = (
    <Provider store={store}>
      <Router>
        <AppRoutes />
      </Router>
    </Provider>
  );

  if (msalInstance) {
    return <MsalProvider instance={msalInstance}>{content}</MsalProvider>;
  }
  return content;
}

export default App;
